import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrWorkspaceDeveloperState.ts
var t = () => e("workspaceDeveloperState");
//#endregion
export { t as useTrWorkspaceDeveloperState };
